export default "__VITE_ASSET__Bb74SMsZ__"